export default __webpack_public_path__ + "static/office-worker-1-dcb8f3fc010bdfde07b58f3340caa29e.jpg";